// Listing modes for the Opportunities module.
//
// Modes are ROUTES (see OpportunityLayout.tsx). localStorage now holds only the
// LAST-VISITED route so bare /opportunities can restore it — it is no longer
// the source of truth for which view is showing, as it was under the old
// local-state switcher.
export const MODE_STORAGE_KEY = "opportunities.viewMode";

export const MODE_PATHS = [
  "/opportunities/pipeline",
  "/opportunities/list",
  "/opportunities/dashboard",
] as const;

export const DEFAULT_MODE_PATH = "/opportunities/list";

/**
 * Resolve the redirect target for a bare /opportunities visit.
 *
 * Migration note: the previous switcher stored a bare mode NAME ("pipeline" |
 * "list" | "dashboard") under this same key. Accept both shapes so a user who
 * had a mode remembered doesn't land somewhere unexpected on first load after
 * this ships, and normalise the legacy value to a path on read.
 */
export function readRememberedModePath(): string {
  if (typeof window === "undefined") return DEFAULT_MODE_PATH;
  const stored = window.localStorage.getItem(MODE_STORAGE_KEY);
  if (!stored) return DEFAULT_MODE_PATH;
  if ((MODE_PATHS as readonly string[]).includes(stored)) return stored;
  const legacy = `/opportunities/${stored}`;
  if ((MODE_PATHS as readonly string[]).includes(legacy)) return legacy;
  return DEFAULT_MODE_PATH;
}
